const pendingStatuses = ['pending-review', 'pending', 'processing', 'submitted', 'in-review']
const rejectedStatuses = ['rejected', 'registration-failed', 'register-failed']
const failedStatuses = [...rejectedStatuses, 'payment-failed', 'unverified', 'deleted']
/**
 *
 */
export {
    pendingStatuses,
    rejectedStatuses,
    failedStatuses
}
